import { COLLAPSE_LINE_ITEMS, EXPAND_LINE_ITEMS } from "./actionTypes";

export const collapseLineItems = (flag = null) => {
  return {
    type: COLLAPSE_LINE_ITEMS,
    payload: flag,
  };
};
export const expandLineItems = (flag = null) => {
  return {
    type: EXPAND_LINE_ITEMS,
    payload: flag,
  };
};
